import { SpeechDetector, useAvContext } from "@minervaproject/avsubsystem";
import { MutableRefObject, useCallback, useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { setUserIsSpeaking } from "shared/reducers/classroom";
import { localSelectors } from "store";
import { selectEffectivePttMode } from "store/selectors/classroom";

// Has a speech detector and observes it to notify about speech events

const SPEECH_DETECTOR_INTERVAL = 125;

function SpeechDetectorObserver() {
  const dispatch = useAppDispatch();
  const avConnection = useAvContext();
  const userId = useAppSelector(localSelectors.selectCurrentUserId());

  const handleSpeechIndicationSignal = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (isSpeaking: boolean, offset: number) => {
      dispatch(setUserIsSpeaking({ userId, isSpeaking }));
    },
    [dispatch, userId],
  );

  const speechDetector: MutableRefObject<SpeechDetector | null> = useRef(null);
  const pttMode = useAppSelector(selectEffectivePttMode(userId));

  useEffect(() => {
    if (!avConnection) return;

    if (!speechDetector.current) {
      speechDetector.current = new SpeechDetector(
        avConnection,
        SPEECH_DETECTOR_INTERVAL,
        handleSpeechIndicationSignal,
      );
    }

    if (!pttMode) {
      speechDetector.current.startListening();
    } else {
      speechDetector.current.stopListening();
      dispatch(setUserIsSpeaking({ userId, isSpeaking: false }));
    }
  }, [pttMode, speechDetector, avConnection, handleSpeechIndicationSignal, dispatch, userId]);

  return null;
}

export { SpeechDetectorObserver };
